// @ts-nocheck
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./component/layout";
import {
  Explore,
  HomePage,
  NotFoundPage,
  ReminderPage,
  ServicePage,
  SparePartPage,
  UsedCarsPage,
} from "./component/pages";

import PrivateRoute from "./component/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
// import { login } from "./redux/authSlice";
import Login from "./component/auth/Login";
import { login } from "./redux/authSlice";
import { useNavigate } from "react-router-dom";
import { Services } from "./component/Service/Services";
import { SpareParts } from "./component/SpareParts/SpareParts";
import { UsedCars } from "./component/UsedCars/UsedCars";
import { Chat } from "./component/Chat/Chat";
import { Customers } from "./component/Customers/Customers";
import { Offers } from "./component/Offers/Offers";
import { OrderHistory } from "./component/OrderHistory/OrderHistory";
import { Reminder } from "./component/Reminder/Reminder";
import Privacy from "./component/Privacy/Privacy";
import { UsedCarsEnquiriesTabel } from "./component/UsedCars/UsedCarsEnquiriesTabel";
// import TermsAndConditions from "./component/Privacy/TermsAndConditions";
import TermsAndConditions from "./component/Privacy/TermsAndConditions";
import LanguageSelector from "./component/settings/LanguageSelector";
import UnauthorizedIndex from "./component/unauthorized";
import { ErrorBoundary } from "react-error-boundary";
import ServiceHistory from "./component/history/ServiceHistory";
import UsedCarBookingHistory from "./component/history/UsedCarBookingHistory";
import { fetchCountNotifications } from "./redux/notificationsThunk";
// import useSocket from "./hooks/useSocket";


function App() {


  return (
    <>

      <Router>
        <ErrorBoundary
          FallbackComponent={UnauthorizedIndex}
        >

          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/termsAndConditions" element={<TermsAndConditions />} />

            <Route path="" element={<NotFoundPage />} />

            <Route
              path="/unauthorized"
              element={
                <UnauthorizedIndex />
              }

            />

            <Route
              element={<PrivateRoute allowedRoles={["admin", "carSeller"]} />}
            >
              <Route path="/home" element={<HomePage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/usedCars" element={<UsedCars />} />
              <Route path="/sparePart" element={<SpareParts />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/reminder" element={<Reminder />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/orderHistory" element={<OrderHistory />} />
              <Route path="/enquiries" element={<UsedCarsEnquiriesTabel />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/service-booking-history" element={<ServiceHistory />} />
              <Route path="/usedCar-booking-history" element={<UsedCarBookingHistory />} />

            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ErrorBoundary>
      </Router>
    </>
  );
}

export default App;
